import React, { Component } from "react";
import "./LineReader.css";
import dragIcon from "../../assets/images/dragicon.png";
import stretchIcon from "../../assets/images/menus.png";
import { registerReader, unregisterReader } from "./line-reader-manager";

class LineReader extends Component {
  constructor(props) {
    super(props);
    this.frame = null;
    this.pendingState = null;
    this.state = {
      visible: false,
      left: 150,
      top: 150,
      innerHeight: 40,
      innerWidth: 200,
      outerHeight: 60,
    };
    this.initialState = { ...this.state };
    this.mode = null;
  }

  componentDidMount() {
    registerReader(this);
  }

  componentWillUnmount() {
    unregisterReader(this);
  }

  toggle = () => {
    this.setState({ visible: !this.state.visible });
  };

  show = () => {
    this.setState({ visible: true });
  };

  reset = () => {
    this.setState({ ...this.initialState });
  };

  hide = () => {
    this.setState({ visible: false });
  };

  applyFrame = () => {
    if (!this.pendingState) return;

    this.setState(this.pendingState);
    this.pendingState = null;
    this.frame = null;
  };

  // ================= DRAG =================
  handleDragStart = (e) => {
    e.stopPropagation();
    this.mode = "drag";
    document.body.classList.add("no-select"); // 👈 ADD THIS
    this.parentRect = this.containerRef.parentNode.getBoundingClientRect();
    this.wrapperRect = this.containerRef.getBoundingClientRect();
    this.startX = e.clientX;
    this.startY = e.clientY;

    this.startLeft = this.state.left;
    this.startTop = this.state.top;

    document.addEventListener("mousemove", this.onMouseMove);
    document.addEventListener("mouseup", this.onMouseUp);
  };

  // ================= INNER RESIZE =================
  handleWidthResizeStart = (e) => {
    e.stopPropagation();

    this.mode = "innerResize";
    document.body.classList.add("no-select"); // 👈 ADD THIS
    this.parentRect = this.containerRef.parentNode.getBoundingClientRect();
    this.wrapperRect = this.containerRef.getBoundingClientRect();
    this.startY = e.clientY;
    this.startX = e.clientX;

    this.startInnerHeight = this.state.innerHeight;
    this.startWidth = this.containerRef.offsetWidth;

    document.addEventListener("mousemove", this.onMouseMove);
    document.addEventListener("mouseup", this.onMouseUp);
  };

  // ================= OUTER RESIZE =================
  handleHeightResizeStart = (e) => {
    e.stopPropagation();
    this.parentRect = this.containerRef.parentNode.getBoundingClientRect();
    this.wrapperRect = this.containerRef.getBoundingClientRect();
    this.mode = "outerResize";
    document.body.classList.add("no-select"); // 👈 ADD THIS

    this.startY = e.clientY;
    this.startOuterHeight = this.state.outerHeight;

    document.addEventListener("mousemove", this.onMouseMove);
    document.addEventListener("mouseup", this.onMouseUp);
  };

  // ================= MOUSE MOVE =================
  onMouseMove = (e) => {
    if (!this.mode) return;

    const MARGIN = -10;
    // DRAG
    if (this.mode === "drag") {
      const dx = e.clientX - this.startX;
      const dy = e.clientY - this.startY;

      let newLeft = this.startLeft + dx;
      let newTop = this.startTop + dy;

      const parentWidth = this.parentRect.width;
      const parentHeight = this.parentRect.height;

      const elWidth = this.containerRef.offsetWidth;
      const elHeight = this.containerRef.offsetHeight;

      // 👉 CLAMP X
      if (newLeft < MARGIN) newLeft = MARGIN;
      if (newTop < MARGIN) newTop = MARGIN;

      if (newLeft + elWidth > parentWidth - MARGIN) {
        newLeft = parentWidth - elWidth - MARGIN;
      }

      if (newTop + elHeight > parentHeight - MARGIN) {
        newTop = parentHeight - elHeight - MARGIN;
      }

      this.pendingState = {
        ...this.pendingState,
        left: newLeft,
        top: newTop,
      };
    }

    // INNER RESIZE (height + width)
    if (this.mode === "innerResize") {
      const dy = e.clientY - this.startY;
      const dx = e.clientX - this.startX;
      let newInner = this.startInnerHeight + dy;
      let newWidth = this.startWidth + dx;

      const parentWidth = this.parentRect.width;
      const parentHeight = this.parentRect.height;

      const currentTop = this.state.top;
      const outerHeight = this.state.outerHeight;

      let maxInnerHeight = parentHeight - currentTop - outerHeight;

      if (newInner > maxInnerHeight) newInner = maxInnerHeight;
      if (newInner < 40) newInner = 40;

      // 👉 WIDTH LIMIT (stay inside parent)
      const maxWidth = parentWidth - this.state.left - MARGIN;
      if (newWidth > maxWidth) newWidth = maxWidth;
      if (newWidth < 200) newWidth = 200;

      this.pendingState = {
        ...this.pendingState,
        innerHeight: newInner,
        innerWidth: newWidth,
      };

      // this.containerRef.style.width = newWidth + "px";
    }

    // OUTER RESIZE
    if (this.mode === "outerResize") {
      const dy = e.clientY - this.startY;

      let newOuter = this.startOuterHeight + dy;
      if (newOuter < 40) newOuter = 40;

      const parentHeight = this.parentRect.height;
      const currentTop = this.state.top;
      const innerHeight = this.state.innerHeight;

      let maxOuterHeight = parentHeight - currentTop - innerHeight;
      if (newOuter > maxOuterHeight) newOuter = maxOuterHeight;
      // this.setState({
      //   outerHeight: newOuter
      // });
      this.pendingState = {
        ...this.pendingState,
        outerHeight: newOuter,
      };
    }

    if (this.mode === "drag") {
      document.body.style.cursor = "grabbing";
    } else if (this.mode === "innerResize") {
      document.body.style.cursor = "nwse-resize";
    } else if (this.mode === "outerResize") {
      document.body.style.cursor = "ns-resize";
    }

    if (!this.frame) {
      this.frame = requestAnimationFrame(this.applyFrame);
    }
  };

  // ================= MOUSE UP =================
  onMouseUp = () => {
    this.mode = null;
    document.body.style.cursor = "default";
    document.body.classList.remove("no-select"); // 👈 IMPORTANT
    document.removeEventListener("mousemove", this.onMouseMove);
    document.removeEventListener("mouseup", this.onMouseUp);
  };

  render() {
    if (!this.state.visible) return null;

    return (
      <div className="reading-container">
        <div
          id="wrapper"
          className="reading-wrapper"
          ref={(ref) => (this.containerRef = ref)}
          style={{
            transform: `translate(${this.state.left}px, ${this.state.top}px)`,
          }}
          onMouseDown={this.handleDragStart}
        >
          {/* READER BOX */}
          <div
            className="readerBox"
            style={{
              height: this.state.innerHeight,
              width: this.state.innerWidth,
            }}
          >
            {/* DRAG HANDLE */}
            <div
              className="handleResize"
              onMouseDown={this.handleWidthResizeStart}
            >
              <img src={dragIcon} alt="Drag" className="drag-icon" />
            </div>

            {/* INNER RESIZE */}
            <div />
          </div>

          {/* OVERLAY AREA */}
          <div
            className="readerContent"
            style={{
              height: this.state.outerHeight,
            }}
          >
            <div
              className="heightStretch"
              onMouseDown={this.handleHeightResizeStart}
            >
              <img src={stretchIcon} alt="Stretch" className="stretch-icon" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LineReader;
